import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";

import { HsLegendModule } from "hslayers-ng";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxSliderModule } from "@angular-slider/ngx-slider";

import { AcMapOverlayComponent } from "./map-overlay.component";
import { LegendComponent } from "./legend/legend.component";
import { LayermanagerComponent } from "./layermanager/layermanager.component";
import { LocationSwitcherComponent } from "./location-switcher/location-switcher.component";

import { HsLayerManagerModule } from "hslayers-ng";
import { LayerListItemComponent } from './layermanager/layer-list-item/layer-list-item.component';
@NgModule({
  declarations: [
    AcMapOverlayComponent,
    LegendComponent,
    LayermanagerComponent,
    LocationSwitcherComponent,
    LayerListItemComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HsLegendModule,
    NgbDropdownModule,
    NgxSliderModule,
    HsLayerManagerModule,
  ],
  exports: [AcMapOverlayComponent],
  providers: [],
  entryComponents: [AcMapOverlayComponent],
})
export class AcMapOverlayModule {}
